import React, { useEffect } from "react";
import Styled from "styled-components";
import Sapimg from "../Images/SAPImage.png";
import lie from "../Images/lie.jpg";
export default function Sap() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <DIV>
      <BOX>
        <h1>Visiting Faculty Programs</h1>

        <COLOR>
          <TOP>
            <p className="above">
              The faculty members of the Universities and colleges in India and
              abroad can visit the Centre for their specific research
              programmes, or for attending the course work/ training programme.
              The duration of visit may be restricted to maximum three months in
              one year. The Centre will provide both financial and technical
              support to carry out the research work.
            </p>
            
          </TOP>
        </COLOR>
      </BOX>
    </DIV>
  );
}
const H3 = Styled.h3`
    font-family: PT Serif;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 26px;
    color: #000000;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
    @media (max-width:395px){
      font-size: 14px;
    }
   `;
const H4 = Styled.h4`
   font-family: PT Serif;
   font-style: normal;
   font-weight: normal;
   font-size: 20px;
   line-height: 16px;
   color:#8585e7;
   @media (max-width:640px){
    font-size: 18px;
  }
  @media (max-width:540px){
    font-size: 16px;
  }
  @media (max-width:395px){
    font-size: 14px;
  }`;
const DIV = Styled.div`

background: #FAFAFA;
display:flex ;
justify-content:center;
align-items: center;
width:100%;
`;

const BOX = Styled.div`

width:85%;
margin:50px auto;
h1{
  font-family: Oswald;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 36px;
  font-weight:500;
  color: #E01E38;
  display:flex;
 }
 @media (max-width:1132px){
 h1{
  font-size: 32px;
  }
}
@media (max-width:1065px){
  h1{
   font-size: 31px;
   }
 }
 @media (max-width:534px){
  h1{
   font-size: 28px;
   }
 }
 @media (max-width:395px){
  padding: 16px;
  h1{
   font-size: 26px;
   }
 }
li{
    margin-left:50px;
    text-align:justify;
    font-size:20px;
    line-height:24px;
    font-family: PT Serif;
   
}
@media (max-width:640px){
   li{
    font-size:18px;
   }
}
@media (max-width:534px){
  li{
    font-size:16px;
  }
 }
 @media (max-width:395px){
  li{
    font-size:14px;
  }
 }
`;
const COLOR = Styled.div`
background:white;
padding:20px 40px;
box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
`;

const TOP = Styled.div`
@media (max-width:530px){
  display:flex;
  flex-direction:column;
  align-items:center;
}
 p.above{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
  }
 p.below{
    font-family: PT Serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
    text-align:justify;
    @media (max-width:640px){
      font-size: 18px;
    }
    @media (max-width:540px){
      font-size: 16px;
    }
 }


`;
